import {
  ShippingCalculationRequest,
  ShippingCalculationResponse,
  ShippingCalculationResult,
} from "../types/shipping";

import apiClient from "./apiClient";

export const shippingService = {
  calculateShipping: async (
    request: ShippingCalculationRequest
  ): Promise<ShippingCalculationResponse> => {
    try {
      const response = await apiClient.post<ShippingCalculationResult>(
        "/Shipping/calculate",
        request
      );

      if (!response.data.isSuccess || !response.data.data) {
        throw new Error(
          response.data.message || "Failed to calculate shipping cost"
        );
      }

      return response.data.data;
    } catch (error: any) {
      throw error;
    }
  },
};

export default shippingService;
